import axios from 'axios';
import type { UserSessionApiPayload } from '@/types/user';
import { getApiBaseUrl } from '@/config/backendBaseUrl';

/**
 * Актуальные данные пользователя (тот же контракт, что после userAuthorize).
 * bx_id / bx_hash — заголовки X-Bx-Id и X-Bx-Hash (см. axiosSessionAuth, App.vue watch).
 */
export async function refreshCurrentUser(): Promise<UserSessionApiPayload> {
    const url = `${getApiBaseUrl()}/ajax/user/getCurrentUser/`;
    const { data } = await axios.get<UserSessionApiPayload>(url);
    return data;
}
